import { AwardBadgeSvg } from '@client/components/award-badge-svg/AwardBadgeSvg';
import { awards as awardsSettings } from '@settings';
import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { vendorAwardsAtom } from '../../../../jotai/storefront/awards-summary';
import { withinDateRange } from '../../../../utils/withinDateRange';
import { BowBadgePaths, HofBadgePaths } from './badge-svg-paths';

const { startDate, endDate } = awardsSettings;
export const ENHANCED_BADGE_LABELS = {
	BOW: 'Best of Weddings Award',
	BOWHOF: 'Hall of Fame Award',
};

export const AwardSingleItem = () => {
	const awards = useAtomValue(vendorAwardsAtom);
	const firstAward = awards[0];

	const imageKey = useMemo(() => {
		if (!firstAward) return null;
		// NOTE (Q2): The atom sorts BOW awards descending by year with HOF last.
		// This means a vendor holding both BOW2026 AND Hall of Fame will have
		// BOW2026 as awards[0]. During the narrow window before BOW2026 is
		// released (withinDateRange === false), the guard below fires and the
		// component returns null — the HOF badge is NOT shown as a fallback.
		// This is intentional per the task specification. If QA flags this as a
		// bug, revert to checking awards[1] as a fallback when awards[0] is
		// filtered by the date guard.
		if (
			firstAward.type === 'BOW' &&
			firstAward.year === 2026 &&
			!withinDateRange({ startDate, endDate })
		) {
			return null;
		}

		const hasHOF = awards.some((award) => award.type === 'HOF');
		return hasHOF ? 'BOWHOF' : 'BOW';
	}, [awards, firstAward]);

	if (!imageKey) {
		return null;
	}

	const badgeLabel =
		imageKey === 'BOWHOF'
			? ENHANCED_BADGE_LABELS.BOWHOF
			: ENHANCED_BADGE_LABELS.BOW;

	return (
		<AwardBadgeSvg label={badgeLabel}>
			{imageKey === 'BOWHOF' ? <HofBadgePaths /> : <BowBadgePaths />}
		</AwardBadgeSvg>
	);
};
